import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

/* -------------------- ALL ENQUIRIES -------------------- */
export const AllEnquiriesThunk = createAsyncThunk(
  "enquiries/AllEnquiriesThunk",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axios.get(`/api/admin/product-enquiries/list`);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || "Failed to fetch enquiries"
      );
    }
  }
);

/* -------------------- GET SINGLE ENQUIRY -------------------- */
export const GetSingleEnquiryThunk = createAsyncThunk(
  "enquiries/GetSingleEnquiryThunk",
  async (uuid, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        `/api/admin/product-enquiries/show?uuid=${uuid}`
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || "Failed to fetch enquiry details"
      );
    }
  }
);

/* -------------------- ADD ENQUIRY -------------------- */
export const AddEnquiryThunk = createAsyncThunk(
  "enquiries/AddEnquiryThunk",
  async (formData, { rejectWithValue }) => {
    try {
      const response = await axios.post(`/api/admin/product-enquiries/add`, formData);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Failed to add enquiry");
    }
  }
);

/* -------------------- UPDATE ENQUIRY -------------------- */
export const UpdateEnquiryThunk = createAsyncThunk(
  "enquiries/UpdateEnquiryThunk",
  async (formData, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `/api/admin/product-enquiries/update`,
        formData
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || "Failed to update enquiry"
      );
    }
  }
);

/* -------------------- DELETE ENQUIRY -------------------- */
export const DeleteEnquiryThunk = createAsyncThunk(
  "enquiries/DeleteEnquiryThunk",
  async (uuid, { rejectWithValue }) => {
    try {
      const response = await axios.get(`/api/admin/product-enquiries/delete?uuid=${uuid}`);
      return {
        uuid,
        message: response.data?.message || "Deleted successfully",
      };
    } catch (error) {
      return rejectWithValue(
        error.response?.data || "Failed to delete enquiry"
      );
    }
  }
);
